import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "vb_admin_token";

export const tokenStore = {
  get: () => localStorage.getItem(ADMIN_TOKEN_KEY),
  set: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
};

export const api = axios.create({
  baseURL: API_BASE,
  // Auth is JWT via Authorization: Bearer header (see interceptor below).
  // Do NOT enable withCredentials — it turns every request into a
  // "credentialed" CORS request, which browsers reject when the response
  // has Access-Control-Allow-Origin: * (the fastapi default). That mismatch
  // was silently converting successful writes into "Something went wrong"
  // errors on production.
});

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
